import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './auth-token.reducer';
import { IAuthToken } from 'app/shared/model/auth-token.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AuthToken = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const authTokenList = useAppSelector(state => state.authToken.entities);
  const loading = useAppSelector(state => state.authToken.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="auth-token-heading" data-cy="AuthTokenHeading">
        <Translate contentKey="comexApp.authToken.home.title">Auth Tokens</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.authToken.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.authToken.home.createLabel">Create new Auth Token</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {authTokenList && authTokenList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="comexApp.authToken.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="comexApp.authToken.accessToken">Access Token</Translate>
                </th>
                <th>
                  <Translate contentKey="comexApp.authToken.expiresIn">Expires In</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {authTokenList.map((authToken, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${authToken.id}`} color="link" size="sm">
                      {authToken.id}
                    </Button>
                  </td>
                  <td>{authToken.accessToken}</td>
                  <td>{authToken.expiresIn}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${authToken.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button tag={Link} to={`${match.url}/${authToken.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button tag={Link} to={`${match.url}/${authToken.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.authToken.home.notFound">No Auth Tokens found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AuthToken;
